import { render, staticRenderFns } from "./PersonalStatusReport.vue?vue&type=template&id=a488ee0e&scoped=true&"
import script from "./PersonalStatusReport.vue?vue&type=script&lang=js&"
export * from "./PersonalStatusReport.vue?vue&type=script&lang=js&"
import style0 from "./PersonalStatusReport.vue?vue&type=style&index=0&id=a488ee0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a488ee0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemTitle,VSimpleTable})
